import React, { useEffect } from 'react';
import closeIcon from "../../assets/close-icon.png"
import checkIcon from "../../assets/check-filled-icon.png"
import { useDispatch, useSelector } from 'react-redux';
import { resetDocumentsState, resetSelectedSender, resetSelectedReceiver, resetSelectedAgent, clearTaricJsonErrors } from '../../store/reducers';
import { AlertTriangle, TriangleAlert } from 'lucide-react';
import { useLanguage, getGeneratedSuccessfullyModalTranslation } from '../../hooks/useLanguage';

export const GeneratedSuccessfullyModal = ({ 
  setIsSuccessfulModalOpen, 
  setIsProcessing, 
  setIsReviewConfirmed,
  hasError = false,
  errorMessage = "An error occurred while generating the Taric declaration.",
  onRetry
}) => {
  const dispatch = useDispatch();
  const [isSpanish] = useLanguage();
  const successfulExpedientes = useSelector((state) => state.preparedJson.successfulExpedientes || []);
  const errorExpedientes = useSelector((state) => state.preparedJson.errorExpedientes || []);
  
  // Format expedientes list with commas
  const formatExpedientes = (expedientes) => {
    if (expedientes.length === 0) return '';
    return expedientes.join(', ');
  };

  const handleClose = () => {
    // dispatch(resetDocumentsState()); 
    // dispatch(resetSelectedSender());
    // dispatch(resetSelectedReceiver());
    // dispatch(resetSelectedAgent());
    // setIsProcessing(false);
    // setIsReviewConfirmed(false);
    setIsSuccessfulModalOpen(false);
  }

  const handleSuccessfulClose = () => {
    // Clear all sessionStorage items related to processing when declaration is generated successfully
    sessionStorage.removeItem('hasCompletedJob');
    sessionStorage.removeItem('originalExtractedData');
    sessionStorage.removeItem('activeJobId');
    sessionStorage.removeItem('documentReadyReceived');
    sessionStorage.removeItem('lastJobId'); // Clear lastJobId to prevent restore button from appearing
    
    // Clear active job to stop the stream
    window.dispatchEvent(new CustomEvent('clearActiveJobId'));
    
    window.location.reload();
    // dispatch(resetDocumentsState()); 
    // dispatch(resetSelectedSender());
    // dispatch(resetSelectedReceiver());
    // dispatch(resetSelectedAgent());
    // dispatch(clearTaricJsonErrors());
    // setIsProcessing(false);
    // setIsReviewConfirmed(false);
    // setIsSuccessfulModalOpen(false);
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-999 text-center">
      <div className="bg-white p-4 rounded-xl shadow-lg max-w-md w-full">
        <div className='flex justify-end'>
          <img className='h-6 w-6 cursor-pointer' src={closeIcon} onClick={() => hasError ? handleClose() : handleSuccessfulClose()} />
        </div>
        <div className="flex flex-col items-center mb-4">
          {/* Show icon based on whether there are errors (even if there are also successes) */}
          {(errorExpedientes.length > 0 && successfulExpedientes.length === 0) ? (
            <AlertTriangle className="p-4 h-24 w-24 mb-4 text-red-500 stroke-red-500" />
          ) : (
            <img className="h-24 w-24 mb-2" src={checkIcon} alt="Success" />
          )}

  {(errorExpedientes.length > 0 &&
   (successfulExpedientes.length > 0) && (
            <h2 className="text-xs font-light mb-1">{isSpanish ? "Exportaciones generadas con éxito" : "Exports successfully generated"}</h2>
          ))}

          {/* Display successful expedientes as big H1 */}
          {successfulExpedientes.length > 0 && (
            <h1 className="text-3xl font-bold mb-2 text-template-primary">
              {formatExpedientes(successfulExpedientes)}
            </h1>
          )}
          
          {/* Display error expedientes - large if no successful ones, small if there are successful ones */}
          {errorExpedientes.length > 0 && (
            successfulExpedientes.length === 0 ? (
              <h1 className="text-3xl font-bold mb-2 text-red-500">
                {formatExpedientes(errorExpedientes)}
              </h1>
            ) : (
              <div className="flex items-center gap-1 mt-4 flex-col mb-4">
                <h2 className="text-xs font-light">{isSpanish ? "Exportaciones con errores" : "Exports with errors"}</h2>
                <p className="text-xl font-semibold text-red-500">
                  {formatExpedientes(errorExpedientes)}
                </p>
              </div>
            )
          )}
          
          
          <h2 className="text-xl font-bold mb-2 mt-4">
            {errorExpedientes.length > 0 
              ? getGeneratedSuccessfullyModalTranslation('generationFailed', isSpanish) 
              : getGeneratedSuccessfullyModalTranslation('taricDeclarationSuccess', isSpanish)}
          </h2>
          
          {/* Show message based on results */}
          {errorExpedientes.length > 0 ? (
            <>
              <p className='opacity-75 text-sm mb-4'>{errorMessage}. {getGeneratedSuccessfullyModalTranslation('closeToCheckErrors', isSpanish)}</p>
            </>
          ) : (
            <p className='opacity-75 text-sm'>{getGeneratedSuccessfullyModalTranslation('yourDeclarationSaved', isSpanish)}</p>
          )}
        </div>
      </div>
    </div>
  );
};